export default __webpack_public_path__ + "static/media/clouds.3c700c13.png";